import { Send01, Check, XClose } from '@untitled-ui/icons-react'

import MentionTextarea from './MentionTextarea'

export default function CommentComposer({
    value,
    onChange,
    onSubmit,
    onCancel,
    profiles,
    profilesMap,
    placeholder = 'Écrire un commentaire...',
    submitLabel = 'Envoyer',
    isEditing = false,
    isSaving = false,
}) {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
            e.preventDefault()
            onSubmit()
        }
        if (e.key === 'Escape' && onCancel) {
            onCancel()
        }
    }

    const isEmpty = !value.trim()

    return (
        <div
            className="rounded-lg border border-gray-200 bg-white focus-within:border-gray-400 transition-colors"
            onKeyDown={handleKeyDown}
        >
            <div className="px-3 py-2.5">
                <MentionTextarea
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    profiles={profiles}
                    profilesMap={profilesMap}
                />
            </div>

            <div className="flex items-center justify-end px-2.5 py-1.5 border-t border-gray-100">
                <span className="text-[10px] text-gray-400 mr-auto select-none">
                    ⌘↵
                </span>

                <div className="flex items-center gap-1">
                    {onCancel && (
                        <button
                            onClick={onCancel}
                            className="p-1 text-gray-400 hover:text-gray-600 rounded-sm transition-colors cursor-pointer"
                        >
                            <XClose width={14} height={14} />
                        </button>
                    )}
                    <button
                        onClick={onSubmit}
                        disabled={isEmpty || isSaving}
                        className="flex items-center gap-2 px-2 py-0.5 leading-none text-gray-400 hover:text-gray-900 disabled:opacity-20 disabled:cursor-not-allowed transition-colors cursor-pointer rounded-sm"
                        style={{ fontSize: 13 }}
                    >
                        {isEditing ? (
                            <>
                                <Check width={14} height={14} />
                            </>
                        ) : (
                            <>
                                <Send01 width={14} height={14} />
                                <span>Envoyer</span>
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    )
}
